export default __webpack_public_path__ + "static/media/3ba73a0bbd361e37565769af316ecf5b1602890580235.1fbefda2.webp";